<template><div></div></template>

<script>
import Auth from "../apis/Auth";
export default {
  created() {
    if (this.$route.query.state) {
      let state = {};
      try {
        state = JSON.parse(this.$route.query.state);
      } catch (_) {
        //
      }
      if (state.reseller_domain) {
        const url = new URL(window.location.href);
        if (url.hostname != state.reseller_domain) {
          url.hostname = state.reseller_domain;
          window.location.replace(url.toString());
          return;
        }
      }
    }

    Auth.socialLogin(this.$route.params.provider)
      .then(() => {
        this.$root.$emit("after-login");
        this.$router.push({ path: "/instances" });
      })
      .catch((error) => {
        if (error.response.data.error_type === "account_already_exists") {
          this.$router.push({
            path: "/login",
            query: { account_already_exists: true },
          });
          return;
        }

        this.$router.push({ path: "/login" });
      });
  },
};
</script>
